import RichTextEditor from '../common/RichTextEditor';
import { normalizeClipboardHtml, plainTextToJobHtml, sanitizeJobHtml } from '../../utils/jobHtml';

function isSafeUrl(value) {
  return /^(https?:\/\/|mailto:)/i.test(String(value || '').trim());
}

function normalizeUrl(value) {
  const url = String(value || '').trim();

  if (!url) return '';
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;

  return `https://${url}`;
}

function JobRichTextEditor({ value, onChange }) {
  return (
    <RichTextEditor
      ariaLabel="Job description editor"
      isSafeUrl={isSafeUrl}
      normalizeClipboardHtml={normalizeClipboardHtml}
      normalizePlainText={plainTextToJobHtml}
      normalizeUrl={normalizeUrl}
      onChange={onChange}
      sanitizeHtml={sanitizeJobHtml}
      value={value}
    />
  );
}

export default JobRichTextEditor;
